import { render, staticRenderFns } from "./CartTabMenu.vue?vue&type=template&id=4bbe2b90&scoped=true"
import script from "./CartTabMenu.vue?vue&type=script&lang=ts"
export * from "./CartTabMenu.vue?vue&type=script&lang=ts"
import style0 from "./CartTabMenu.vue?vue&type=style&index=0&id=4bbe2b90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbe2b90",
  null
  
)

export default component.exports